'use client';

import dynamic from 'next/dynamic';

import RichTextEditorSkeleton from '@/components/studio/studio-page-content/rich-text-editor/rich-text-editor-skeleton';

/** BlockNote is large; keep it out of parent bundles (Turbopack merged-module limit). */
export const LazyBlockNoteRichTextRenderer = dynamic(
  () => import('./blocknote-rich-text-renderer'),
  {
    ssr: false,
    loading: RichTextEditorSkeleton,
  },
);
